import { FC, RefObject } from "react";

import { OrganizationCountry } from "@simplyk/common";
import { UseFormReturn } from "react-hook-form";

import { NewsletterFormSignupData } from "../types";

import { isRequired } from "@/common/helpers/validators";
import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardPhoneNumberInput } from "@/dashboard-design-system/PhoneNumberInput";
import { PhoneNumberInputHandle } from "@/dashboard-design-system/PhoneNumberInput/types";

type NewsletterFormPhoneFieldProps = {
  form: UseFormReturn<NewsletterFormSignupData>;
  organization: { country: OrganizationCountry };
  previewConfiguration?: {
    isPreview: boolean;
  };
  phoneNumberInputRef?: RefObject<PhoneNumberInputHandle | null>;
};

export const NewsletterFormPhoneField: FC<NewsletterFormPhoneFieldProps> = ({
  form,
  organization,
  phoneNumberInputRef,
}) => {
  const { t } = useTranslate();
  const { errors } = form.formState;

  return (
    <DashboardPhoneNumberInput
      ref={phoneNumberInputRef}
      name="phoneNumber"
      data-test="form-phone-number"
      control={form.control}
      rules={[isRequired(t("dashboard", "newsletterForms.editor.step.questions.field.phoneNumber.required"))]}
      errorMessage={errors.phoneNumber?.message}
      noAsterisk
      organizationCountry={organization?.country}
      skipCountryValidation={true}
    />
  );
};
